import classNames from 'classnames';

import Button from '~components/Button/Button';

import { BenefitData } from '../BenefitsExplorer';

const DetailsTab = ({ benefit }: { benefit: BenefitData }) => {
    return (
        <div className={classNames('hidden md:flex flex-col h-fit', 'shadow-md', 'benefits:w-2/3')}>
            {benefit.image}
            <div
                className={classNames(
                    'px-3 py-6',
                    'lg:py-12 lg:px-24',
                    'bg-white rounded-b-lg max-w-[792px]'
                )}
            >
                <h3
                    className={classNames(
                        'font-bold',
                        'text-24 leading-32 mb-2',
                        'lg:text-32 lg:leading-40 lg:mb-7'
                    )}
                >
                    {benefit.heading}
                </h3>
                <p className="text-16 lg:text-18 mb-6 lg:mb-10">{benefit.body}</p>
                <div className="flex justify-center lg:justify-start">
                    <Button
                        islink
                        forceATag
                        href={process.env.GATSBY_EHMP_URL}
                        styletype="primary"
                        className="w-max"
                        data-wa-link={`Feature Benefits: ${benefit.name}: ${benefit.cta}`}
                        data-filter={benefit.filter}
                    >
                        <span className="hidden lg:inline">{benefit.cta}</span>
                        <span className="lg:hidden font-poppins">Compare plans</span>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default DetailsTab;
